import axios from 'axios';
import authHeader from '../auth-header';
import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";
const getInformasiUmum = 'informasi-umum';
const postInformasiUmumUrl = 'informasi-umum';
const putInformasiUmum = 'informasi-umum/';
const deleteInformasiUmum = 'informasi-umum/';
const exportInformasiUmum = 'informasi-umum-export';

class InformasiService {
 
    postInformasiUmum(formData) {
        var headers = authHeader();        
        var form = new FormData();
        form.append("judul", formData.judul);
        if (typeof formData.file !== 'undefined') {
            form.append('file', formData.file);
        }
        form.append("deskripsi", formData.deskripsi);
        form.append("statusUpdateFile", "1");
        form.append("status", "1");
        return axios
            .post(API_URL + 'set-informasi-umum', form,{ 
            headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } 
        })
        .then(response => {
            
            return response.data.message;
        });
    }
    
    getInformasiUmum(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getInformasiUmum + '?pageNo=' + currentPage + '&pageSize=' + pageSize +'&filter='+filter,
            {
                headers: authHeader()
            });
    }    
    
    putInformasiUmum(formData) {
        var headers = authHeader(); 
        var form = new FormData();
        form.append("judul", formData.judul);
        if (typeof formData.file !== 'undefined') {
            form.append('file', formData.file);
        }
        form.append("deskripsi", formData.deskripsi);
        form.append("statusUpdateFile", "1");
        form.append("status", "1");
        return axios
        .put(
            API_URL + putInformasiUmum + formData.id, form,
            { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() }  }
        );
    }

    deleteInformasiUmum(formData) {

        return axios
            .delete(
                API_URL + deleteInformasiUmum + formData.id,
                { headers: authHeader() }
            );
    }

    exportInformasiUmum() {
        return axios.get(API_URL + exportInformasiUmum, {
            headers: authHeader(),
            responseType: 'blob',        
        });
    }

}

export default new InformasiService();
